import { render, staticRenderFns } from "./IconInstructor.vue?vue&type=template&id=6b5294eb"
import script from "./IconInstructor.vue?vue&type=script&lang=js"
export * from "./IconInstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports